import {createState} from '../chalet/state';
import {initTabs} from '../chalet/tabs';
import {initCatering} from '../chalet/catering';
import {initCurrency} from '../chalet/currency';
import {initEnquiryModal} from '../chalet/enquiry-modal';
import {initEnquiryForms} from '../chalet/enquiry-form';
import {initAvailability} from '../chalet/availability';
import {initLocationMap} from '../chalet/location-map';
import {initChaletNavigation} from '../chalet/navigation';
import {initGallery} from '../chalet/gallery';

const root = document.getElementById('chalet-blade-page');
if (root) {
    const config = JSON.parse(root.querySelector('[data-chalet-config]').textContent);
    const state = createState({activeTab: root.dataset.initialTab, priceType: root.dataset.initialPriceType, currency: null});
    initTabs(root, state);
    initCatering(root, state);
    initCurrency(root, state, config.currencyUrl);
    const modal = initEnquiryModal(root);
    initAvailability(root, modal);
    initEnquiryForms(root, config);
    initLocationMap(root, state, config.map);
    initGallery();
    initChaletNavigation();
}
